export default __webpack_public_path__ + "static/media/glass.b5bd9263.png";